import ComponentModule from 'lib/component-module';
import { lory } from 'lory.js';
import { debounce } from '../misc';

ComponentModule.AddModule('.affiliates', {
    prefix: 'affiliates-',
    components: [
        {
            name: 'template',
            data(){
                return {
                    lory: null,
                    div: [],
                    isMobile: null,
                    totalSlides: null,
                    currentSlide: 0,
                    desc: null,
                    isLast: false
                };
            },
            watch: {
                isMobile(){
                    this.reset();
                }
            },
            methods: {
                initLory() {
                    this.lory = lory(this.$el, { 
                        classNameFrame: 'affiliates__content',
                        classNameSlideContainer:  'affiliates__list', 
                        classNamePrevCtrl: 'affiliates__prev',
                        classNameNextCtrl: 'affiliates__next', 
                        slidesToScroll: 1,
                        enableMouseEvents: true });

                        this.$el.addEventListener('after.lory.slide', () => {
                            this.currentSlide = this.lory.returnIndex();
                        });

                        // manually check for last slide because lory js
                        // index doesn't work with variable width slides
                        this.$el.querySelector('.affiliates__list').addEventListener('transitionend', () => {
                            this.checkLastSlide();
                        });

                        this.checkLastSlide();
                },
                resize: debounce(function() {
                    this.checkLastSlide();
                }, 500),
                checkLastSlide() {
                    let containerOffset = parseInt(window.innerWidth - this.$el.querySelector('.affiliates__list-container').getBoundingClientRect().right);

                    let lastSlideOffset = parseInt(window.innerWidth - this.$el.querySelector('.affiliates__list li:last-child').getBoundingClientRect().right);
                    // 
                    this.isLast = containerOffset == lastSlideOffset || (lastSlideOffset >= containerOffset - 1 && lastSlideOffset <= containerOffset + 1) ? true : false;
                },
                setIsMobile() {
                    var mql = window.matchMedia('(max-width: 650px)');
                    this.isMobile = mql.matches ? true : false;

                    mql.addEventListener('change',() => {
                        this.isMobile = mql.matches ? true : false;
                    });
                },
                reset() {
                    if (this.isMobile) {
                        this.$refs.desc.remove();
                    } else {
                        if (this.$refs.desc) {
                            return;
                        } else {
                            this.$refs.list.prepend(this.desc);
                        }
                    }
                    this.lory.setup();
                    
                }
            },
            mounted() {
                this.desc = this.$refs.desc;
                this.initLory();
                this.setIsMobile();
                this.reset();
                
                window.addEventListener("resize", this.resize);
            },
            unmounted() {
                window.removeEventListener("resize", this.resize);
            }
        }
    ]
});
